import styled from 'styled-components';

export const ScrollableContent = styled.div`
    max-height: 100%;
    overflow-y: auto;
`;

export const ActiveDirectoryFormWrapper = styled.div`
    display: flex;
    gap: 32px;
    width: 100%;
    max-width: 830px;
    padding: 32px 16px;
    margin: 0 auto;
`;
